module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reservationBox",
    class: {
      firstTime: _vm.canDisplay && _vm.reservation.reservation_type === '初回',
        trial: _vm.canDisplay && _vm.reservation.reservation_type === '体験',
        hasTest: _vm.canDisplay && _vm.reservation.hasTest,
        hasMessage: _vm.canDisplay && _vm.reservation.message !== '',
        grayedOut: !_vm.canDisplay
    },
    style: (_vm.getStyle),
    on: {
      "mousemove": function($event) {
        _vm.mousemoveHandler($event)
      },
      "mouseup": function($event) {
        _vm.mouseupHandler($event)
      },
      "mouseout": function($event) {
        _vm.hover = false
      },
      "click": _vm.clickHandler
    }
  }, [(_vm.canDisplay) ? _c('statelist', {
    attrs: {
      "reservation": _vm.reservation
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n    " + _vm._s(_vm.reduceTimeExp(_vm.reservation.start_time)) + "〜\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    " + _vm._s(_vm.reduceTimeExp(_vm.reservation.end_time)) + "\n  ")]), _vm._v(" "), (_vm.canDisplay) ? _c('div', [_c('div', [_vm._v("\n      " + _vm._s(_vm.reservation.student.fullname) + " 様\n      "), (_vm.isVailedCheck) ? _c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleAttendance(_vm.reservation.student.id)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.attendingState(_vm.reservation.student.id)) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', [_vm._v("\n      " + _vm._s(_vm.reservation.teacher.fullname) + " 先生\n      "), (_vm.isVailedCheck) ? _c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleAttendance(_vm.reservation.teacher.id)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.attendingState(_vm.reservation.teacher.id)) + "\n      ")]) : _vm._e()])]) : _c('p', [_vm._v("予約済み")])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-918a0c92", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-918a0c92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timetable/ReservationBox.vue
// module id = 739
// module chunks = 0